// extracted by mini-css-extract-plugin
module.exports = {"fab":"WalletConnect_fab__2q3D3"};